import { Subject } from 'rxjs';
import { AppConstant } from 'src/app/helper/class/app-constant';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { formBuilder, formDynamicValidator } from 'src/app/helper/interface/response';
import { FormGeneratorComponent } from '../form-generator/form-generator.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { confirmModalData } from 'src/app/shared/interface/modal-interface';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/helper/service/auth.service';


@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {
  data: any = {};
  type: 'CONFIRM' | 'FORM' = 'CONFIRM';
  public onClose: Subject<boolean> | any;
  formField: formBuilder[] = [];
  dynamicValidator: formDynamicValidator[] = [{
    controlName: 'is_alive',
    validatorControl: ['died_on'],
    hideControl: ['died_on'],
    operation: '!=',
    value: 1
  },
  {
    controlName: 'is_alive',
    validatorControl: ['effect_from'],
    hideControl: ['effect_from'],
    value: 1
  }]
  formValue: any = {}
  @ViewChild('basicForm') basicForm: FormGeneratorComponent | undefined;
  theme_color = this.auth.currentSettingValue?.theme_color || '#a5bdfd';
  modalAction: 'delete' | 'logout' | 'confirm' = 'confirm';
  actionIcon = 'las la-question-circle';
  actionTitle = 'Confirm';
  actionMessage = 'Are you sure you want to continue?';
  confirmButtonText = 'Confirm';
  cancelButtonText = 'Cancel';
  constructor(private _bsModalRef: BsModalRef, private auth: AuthService) { }

  public ngOnInit(): void {
    this.onClose = new Subject();
  }

  private getModalAction(): 'delete' | 'logout' | 'confirm' {
    const value = `${this.data?.title || ''} ${this.data?.message || ''} ${this.data?.info_message || ''} ${this.data?.btnOK || ''}`.toLowerCase();
    if (value.includes('logout') || value.includes('log out')) {
      return 'logout';
    }
    if (value.includes('delete') || value.includes('remove')) {
      return 'delete';
    }
    return 'confirm';
  }

  private getActionIcon(): string {
    if (this.modalAction === 'logout') {
      return 'las la-sign-out-alt';
    }
    if (this.modalAction === 'delete') {
      return 'las la-trash-alt';
    }
    return 'las la-question-circle';
  }

  private getActionTitle(): string {
    if (this.data?.title) {
      const title = this.data.title.replace(/^confirm\s+/i, '').replace(/\s+confirm$/i, '').trim();
      return title || this.data.title;
    }
    if (this.modalAction === 'logout') {
      return 'Logout';
    }
    if (this.modalAction === 'delete') {
      return 'Delete';
    }
    return 'Confirm';
  }

  private getActionMessage(): string {
    return this.data?.message || this.data?.info_message || this.getDefaultMessage();
  }

  private getConfirmButtonText(): string {
    if (this.data?.btnOK) {
      return this.data.btnOK;
    }
    if (this.modalAction === 'logout') {
      return 'Logout';
    }
    if (this.modalAction === 'delete') {
      return this.actionTitle;
    }
    return 'Confirm';
  }

  private getDefaultMessage(): string {
    if (this.modalAction === 'logout') {
      return 'Are you sure you want to logout?';
    }
    if (this.modalAction === 'delete') {
      return 'Are you sure you want to delete this item? This action cannot be undone.';
    }
    return 'Are you sure you want to continue?';
  }

  private setModalView(): void {
    this.modalAction = this.getModalAction();
    this.actionIcon = this.getActionIcon();
    this.actionTitle = this.getActionTitle();
    this.actionMessage = this.getActionMessage();
    this.confirmButtonText = this.getConfirmButtonText();
    this.cancelButtonText = this.data?.btnCancel || 'Cancel';
  }

  setInput(data: confirmModalData) {
    this.data = data;
    this.setModalView();
    const formBuild: any = [{
      colName: 'reason_relive',
      title: 'Reason',
      validator: [{ name: 'required', error: 'Reason is Required' }]
    },
    {
      colName: 'is_alive',
      title: 'Is Alive',
      defaultValue: true,
      type: 'checkbox',
      data: [{ name: '', id: true }],
      selectKeyName: 'name',
      selectPrimaryKey: 'id',
      validator: [],
      event: {
        name: 'change',
        isCallback: true
      },
    },
    {
      colName: 'died_on',
      title: 'Date of Death',
      validator: [],
      type: 'DATE',
      monthNavigator: true,
      yearNavigator: true,
      dateFormat: AppConstant.DATE_FORMAT,
      dateRange: AppConstant.DEFAULT_DATE_RANGE,
    },
    {
      colName: 'effect_from',
      title: 'Effect From',
      validator: [],
      type: 'DATE',
      defaultValue: new Date(),
      monthNavigator: true,
      yearNavigator: true,
      dateFormat: AppConstant.DATE_FORMAT,
      dateRange: AppConstant.DEFAULT_DATE_RANGE,
    }];
    const dyn = [{
      controlName: 'is_alive',
      validatorControl: ['died_on'],
      hideControl: ['died_on'],
      value: false,
      validator: [{ name: 'required', error: '' }]
    },
    {
      controlName: 'is_alive',
      validatorControl: ['effect_from'],
      hideControl: ['effect_from'],
      value: true,
      validator: [{ name: 'required', error: 'Effect From Date is Required' }]
    }]
    this.type = data.type == 'FORM' ? 'FORM' : 'CONFIRM'
    if (data.isFormField) {
      this.type = 'FORM'
      this.dynamicValidator = data.dynamicValidator?.length ? data.dynamicValidator : this.dynamicValidator
      this.formField = data.formField?.length ? data.formField : formBuild;
      this.basicForm?.initForm()
      this.basicForm?.changeValidator();
    }
    if (!isEmptyObj(data.formValue)) {
      setTimeout(() => {
        this.basicForm?.setData(data.formValue)
      }, 800);
    }
    console.log('TYPE', this.type, data)
  }

  onChange(ev: any) { }

  get isValid() {
    return !this.basicForm?.isValid();
  }

  public onConfirm(): void {
    if (this.data.isFormField) {
      if (!this.basicForm?.isValid()) {
        return;
      }
    }
    const returnData = this.data.isFormField ? this.basicForm?.getFormValue() : true;
    this.onClose.next(returnData);
    this._bsModalRef.hide();
  }

  public onDelete(): void {
    this.onClose.next('DELETE');
    this._bsModalRef.hide();
  }

  public onCancel(status: any = false): void {
    this.onClose.next(status);
    this._bsModalRef.hide();
  }
}
